import { render, staticRenderFns } from "./step3.vue?vue&type=template&id=24047a36&scoped=true&"
import script from "./step3.vue?vue&type=script&lang=js&"
export * from "./step3.vue?vue&type=script&lang=js&"
import style0 from "./step3.vue?vue&type=style&index=0&id=24047a36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24047a36",
  null
  
)

export default component.exports